import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function UploadModal({ open, onClose, onSuccess, sdpId, token }) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [categoria, setCategoria] = useState("geral");
  const [descricao, setDescricao] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("categoria", categoria);
    formData.append("descricao", descricao);

    try {
      await axios.post(`${API_URL}/api/sdp/${sdpId}/files`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });
      toast.success("Arquivo enviado!");
      onSuccess();
      setFile(null);
      setDescricao("");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao enviar arquivo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Upload de Arquivo</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Arquivo *</Label>
            <Input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              required
            />
          </div>
          <div>
            <Label>Categoria</Label>
            <Select value={categoria} onValueChange={setCategoria}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="geral">Geral</SelectItem>
                <SelectItem value="comercial">Comercial</SelectItem>
                <SelectItem value="tecnico">Tecnico</SelectItem>
                <SelectItem value="referencia">Referencia</SelectItem>
                <SelectItem value="desenho">Desenho</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Descricao</Label>
            <Input
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              placeholder="Descricao do arquivo..."
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancelar</Button>
            <Button type="submit" disabled={loading || !file}>
              {loading ? "Enviando..." : "Enviar"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
